import React from 'react';
import useLocale from '@/hooks/useLocale';
import type { LocaleWithGatorProtectTrialExpired } from '../../../gatorProtect.types';
import {
  ProtectionCardRoot,
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardTitle,
  ProtectionCardDescription,
  ProtectionCardActions,
  ProtectionCardButton,
  ProtectionCardMonarx,
} from '../ProtectionCardCompound';

export const TRIAL_EXPIRED_PROTECTION_CARD_TYPE = 'trialExpired' as const;
export type TrialExpiredProtectionCardType = typeof TRIAL_EXPIRED_PROTECTION_CARD_TYPE;

export type TrialExpiredVariantProps = {
  testId?: string;
  hideButtons?: boolean;
  onActivateProtectionPro?: () => void;
};

const TrialExpiredVariant = ({
  testId = 'protection-card',
  hideButtons = false,
  onActivateProtectionPro,
}: TrialExpiredVariantProps) => {
  const { gatorProtect } = useLocale() as LocaleWithGatorProtectTrialExpired;
  const block = gatorProtect?.summary?.protectionCard?.trialExpired;

  if (!block?.title) {
    return null;
  }

  const activatePro = block.actions?.[0];
  const actionsTestId = `${testId}__actions`;

  return (
    <ProtectionCardRoot testId={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={block.title} />
        <ProtectionCardTextBlock>
          <ProtectionCardTitle>{block.title}</ProtectionCardTitle>
          <ProtectionCardDescription html={block.description} />
          {!hideButtons && activatePro && (
            <ProtectionCardActions actionsTestId={actionsTestId}>
              <ProtectionCardButton
                variant={activatePro.variant}
                hasMultipleButtons={false}
                onClick={onActivateProtectionPro}
                testId={`${testId}__action-${activatePro.key}`}
              >
                {activatePro.label}
              </ProtectionCardButton>
            </ProtectionCardActions>
          )}
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={block.title} />
    </ProtectionCardRoot>
  );
};

export default TrialExpiredVariant;
